import {atom} from "jotai/index";

export const salaryMapAtom = atom({});